/* eslint-disable react/jsx-props-no-spreading */
import React, { ReactNode } from 'react'

export const reveleerButtonType = {
  primary: 'primary',
  secondary: 'secondary',
  icon: 'icon',
  dismissive: 'dismissive'
} as const

export const reveleerButtonSize = {
  small: 'small',
  large: 'large'
} as const

type Props = {
  buttonLabel?: string
  buttonSize: keyof typeof reveleerButtonSize
  buttonType: keyof typeof reveleerButtonType
  id: string
  isDisabled: boolean
  onClick: (() => void) | undefined
  type: 'button' | 'submit'
  children?: ReactNode
}

function ReveleerButton(
  props: Props
): JSX.Element {
  const {
    buttonLabel,
    buttonSize,
    buttonType: buttonTypeProp,
    id,
    isDisabled,
    onClick: onClickProp,
    type,
    children,
    ...rest
  } = props
  const buttonType = isDisabled
    ? 'disabled'
    : buttonTypeProp
  const onClick = () => {
    if (!isDisabled && onClickProp) {
      onClickProp()
    }
  }
  return (
    <button
      /**
       * Have to prop spread because popover wraps this in many
       * cases and the tooltip / popover will not work without this (prop forwarding).
       */
      { ...rest }
      className={ `reveleer-button ${buttonType} ${buttonSize}` }
      disabled={ isDisabled }
      id={ id }
      onClick={ onClick }
      type={ type }
    >
      { children || buttonLabel || '' }
    </button >
  )
}

export default ReveleerButton
